<template>
 <sdPageHeader title="ROI rapport aanvragen"></sdPageHeader>
 <Main>
  <a-row :gutter="25">
   <a-col :span="24">
    <WizardBlock>
     <a-row>
      <a-col :span="24">
       <WizardWrapper>
        <Steps
         :current="current"
         :isFinished="isFinished"
         :status="status"
         :steps="steps"
         size="small"
         @onDone="done"
         @onPrev="prev"
        >
         <template #address>
          <sdCards title="Adres selecteren">
           <!--           <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">-->
           <!--            <line :x2="(Math.cos(-45 * (Math.PI / 180)) * 25)" :y2="30 + Math.sin(-45 * (Math.PI / 180)) * 25"-->
           <!--                  stroke="black"-->
           <!--                  x1="0" y1="30"/>-->
           <!--            <line :x2="(Math.cos(0 * (Math.PI / 180)) * 25)" :y2="30 + Math.sin(0 * (Math.PI / 180)) * 25"-->
           <!--                  stroke="black"-->
           <!--                  x1="0" y1="30"/>-->
           <!--            &lt;!&ndash; If you do not specify the stroke-->
           <!--                 color the line will not be visible &ndash;&gt;-->
           <!--           </svg>-->
           <a-row justify="center">
            <a-col :sm="24" :xs="24">
             <div class="create-account-form">
              <a-form
               :model="addressForm"
               :rules="addressFormRules"
               layout="vertical"
               name="account"
               @finish="globalSearch"
              >
               <a-row :gutter="30">
                <a-col :sm="10" :xs="24">
                 <a-form-item label="Postcode" name="postalCode">
                  <a-input v-model:value="addressForm.postalCode" placeholder=""/>
                 </a-form-item>
                </a-col>
                <a-col :sm="4" :xs="24">
                 <a-form-item label="Huisnummer" name="houseNumber">
                  <a-input v-model:value="addressForm.houseNumber"
                           onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
                           onpaste="let pasteData = event.clipboardData.getData('text'); if(pasteData){pasteData.replace(/[^0-9]*/g,'');}"
                           placeholder="" type="number"/>
                 </a-form-item>
                </a-col>
                <a-col :sm="4" :xs="24">
                 <a-form-item v-if="houseNumberAdditionsOptions.length > 0" label="Toevoeging"
                              name="houseNumberAddition"
                 >
                  <a-select v-model:value="addressForm.houseNumberAddition" :allowClear="true"
                            class="sDash_fullwidth-select"
                            size="large">
                   <a-select-option v-for="(item,index) in houseNumberAdditionsOptions"
                                    :key="index"
                                    :value="item.value" name="energyAllowSingleFuelElectricity">
                    {{ item.key }}
                   </a-select-option>
                  </a-select>
                 </a-form-item>
                </a-col>
                <a-col :sm="6" :xs="24">
                 <a-form-item label="&nbsp;">
                  <a-button :disabled="disabledGlobalSearchButton||globalSearchLoading||loadingHouseNumberAdditions"
                            :loading="globalSearchLoading||loadingHouseNumberAdditions" class="btn-signin w-100"
                            html-type="submit"
                            size="large"
                            type="primary">
                   Zoeken
                  </a-button>
                 </a-form-item>
                </a-col>
               </a-row>
              </a-form>
             </div>
            </a-col>
           </a-row>
          </sdCards>
          <a-row v-if="globalSearchData && globalSearchData.address" :gutter="30">
           <a-col :md="14">
            <sdCards title="Klant selecteren">
             <a-row style="padding: 0 !important;">
              <a-col :xs="24" class="mb-10">
               <a-col class="about-connection-wrapper">
                <sdHeading as="h6" class="mb-5" style="font-size:14px">Nieuwe klanten</sdHeading>
                <a-row :gutter="20"
                       style="padding: 10px !important;border: 1px solid rgba(34,41,47,.125);border-radius:5px;">
                 <a-col :xl="16" :xs="24"
                        class="p-2 mb-2" style="vertical-align: middle;display: table-cell;align-self: center">
                  {{ globalSearchData.address.street }}
                  {{
                   globalSearchData.address.houseNumber
                  }} {{
                   globalSearchData.address.houseNumberAddition ? globalSearchData.address.houseNumberAddition : ''
                  }}<br/>
                  {{ globalSearchData.address.postalCode }} {{ globalSearchData.address.city }} <br/>Nederland
                 </a-col>
                 <a-col :xl="8" :xs="24" justify="end"
                        style="vertical-align: middle;align-self: center;text-align: end">
                  <a-button :disabled="loadingPreFillRelationOnOrder"
                            :loading="loadingPreFillRelationOnOrder"
                            class="mr-2 mb-2 mt-2 w-100"
                            size="large"
                            type="primary-outlined"
                            @click.prevent="handleSelectRelation(globalSearchData.address,'CONSUMER')">
                   Doorgaan als particulier
                  </a-button>
                  <a-button :disabled="loadingPreFillRelationOnOrder"
                            :loading="loadingPreFillRelationOnOrder"
                            class="mb-2 mt-2 w-100"
                            size="large"
                            type="primary-outlined"
                            @click.prevent="handleSelectRelation(globalSearchData.address,'BUSINESS')">
                   Doorgaan als zakelijk
                  </a-button>
                 </a-col>
                </a-row>
               </a-col>
              </a-col>
             </a-row>
             <a-row v-if="globalSearchData.relations.length > 0" justify="center">
              <a-col :sm="24" :xs="24" class="mb-10">
               <a-col class="about-connection-wrapper">
                <sdHeading as="h6" class="mb-5" style="font-size:14px">Bestaande klanten</sdHeading>
                <a-row v-for="relation in globalSearchData.relations" :key="relation.id" :gutter="20"
                       style="padding: 10px !important;border: 1px solid rgba(34,41,47,.125);border-radius:5px;margin-bottom: 8px !important;">
                 <a-col :xl="18" :xs="24" style="vertical-align: middle;display: table-cell;align-self: center;">
                                          <span><strong>{{ relation.fullName }}</strong>
                                                                                      <span class="status-badge ml-2">{{
                                                                                        relation.type && relation.type === 'BUSINESS' ? 'Zakelijk' : 'Particulier'
                                                                                       }}</span>
                                          </span><br/>
                  <span>{{ relation.street }} {{
                    relation.houseNumber
                   }} {{
                    relation.houseNumberAddition ? relation.houseNumberAddition : ''
                   }}<br/> {{ relation.postalCode }} {{ relation.city }}<br/> Nederland</span><br/>
                 </a-col>
                 <a-col :xl="6" :xs="24"
                        style="vertical-align: middle;display: flex;align-self: center;justify-content: end;">
                  <a-button :disabled="loadingPreFillRelationOnOrder"
                            :loading="loadingPreFillRelationOnOrder"
                            class="mr-2 mb-2 mt-2 w-100"
                            size="large"
                            type="primary-outlined"
                            @click.prevent="handleSelectRelation(relation,relation.type)"> Selecteren
                  </a-button>
                 </a-col>
                </a-row>
               </a-col>
              </a-col>
             </a-row>
             <a-row v-if="globalSearchData.coc.length > 0" ustify="center">
              <a-col :sm="24" :xs="24" class="mb-2">
               <sdHeading as="h6" class="mb-5" style="font-size:14px">Gevonden in<img
                :src="require(`@/static/img/kvk.svg`)"
                alt="" class="ml-5"/></sdHeading>
               <a-row v-for="coc in globalSearchData.coc" :key="coc.companyCocNumber" :gutter="30"
                      style="padding: 10px !important;border: 1px solid rgba(34,41,47,.125);border-radius:5px;margin-bottom: 8px !important;">
                <a-col :xl="18" :xs="24"
                       class="p-2" style="vertical-align: middle;display: table-cell;align-self: center">
                                          <span><strong>{{ coc.companyName }} - {{
                                            coc.companyCocNumber
                                           }}</strong></span><br/>
                 <span>{{ coc.street }} {{
                   coc.houseNumber
                  }} {{
                   coc.houseNumberAddition ? coc.houseNumberAddition : ''
                  }}<br/> {{ coc.postalCode }} {{ coc.city }}<br/>Nederland</span>
                </a-col>
                <a-col :xl="6" :xs="24" justify="end"
                       style="vertical-align: middle;align-self: center;text-align: end">
                 <a-button :disabled="loadingPreFillRelationOnOrder"
                           :loading="loadingPreFillRelationOnOrder"
                           class="mr-2 mb-2 mt-2 w-100"
                           size="large"
                           type="primary-outlined"
                           @click.prevent="handleSelectRelation(coc,'BUSINESS')"> Doorgaan als zakelijk
                 </a-button>
                </a-col>
               </a-row>
              </a-col>
             </a-row>
            </sdCards>
           </a-col>
           <a-col :md="10">
            <sdCards style="text-align: center" title="Locatie">
             <img :src="globalSearchData.streetViewImageFileURL" style="width: 100%;height: auto;border-radius:5px">
            </sdCards>
           </a-col>
          </a-row>
          <ActionWrapper>
           <div class="step-action-wrap">
            <div class="step-action-inner">
             <a-row>
              <a-col :xs="24">
               <div class="steps-action">
                <router-link to="/order/flow">
                 <sdButton class="btn-prev" to="" type="primary">
                  <sdFeatherIcons size="16" type="arrow-left"/>
                  <span>Vorige</span>
                 </sdButton>
                </router-link>
               </div>
              </a-col>
             </a-row>
            </div>
           </div>
          </ActionWrapper>
         </template>
         <template #questions>
          <a-form :model="productQuestionForm" :rules="questionRules" layout="vertical"
                  @finish="handleProductQuestions">

           <!-- Model Card -->
           <sdCards class="mb-25" title="Model">
            <a-row :gutter="30">
             <a-col :sm="12" :xs="24" class="mb-25">
              <a-form-item label="Model" name="model">
               <a-select v-model:value="productQuestionForm.model" :allowClear="false"
                         class="sDash_fullwidth-select"
                         name="model"
                         placeholder="Selecteer model"
                         size="large">
                <a-select-option value="DYNESS_DH100F_100">Power Plug Battery 100 KW</a-select-option>
                <a-select-option value="DYNESS_DH100F_71">Power Plug Battery 70 KW</a-select-option>
                <a-select-option value="DYNESS_DH100F_86">Power Plug Battery 85 KW</a-select-option>
                <a-select-option value="DYNESS_DH200F_210">Power Plug Battery 200 KW</a-select-option>
                <a-select-option value="DYNESS_TOWER_10">Power Plug Battery 10 KW</a-select-option>
                <a-select-option value="FOX_ESS_EP11_20">Power Plug Battery 20 KW</a-select-option>
                <a-select-option value="FOX_ESS_EP11_41">Power Plug Battery 40 KW</a-select-option>
                <a-select-option value="FOX_ESS_GMAX">Power Plug Battery GMAX</a-select-option>
               </a-select>
              </a-form-item>
             </a-col>
            </a-row>
           </sdCards>

           <!-- Energieverbruik Card -->
           <sdCards class="mb-25" title="Energieverbruik">
            <a-row :gutter="30">
             <a-col :sm="6" :xs="24" class="mb-25">
              <a-form-item label="Energieverbruik hoog (kWh)" name="consumption_peak">
               <a-input v-model:value="productQuestionForm.consumption_peak"
                        name="consumption_peak"
                        onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
                        onpaste="let pasteData = event.clipboardData.getData('text'); if(pasteData){pasteData.replace(/[^0-9]*/g,'');}"
                        placeholder="Verbruik in daluren"
                        type="number"/>
              </a-form-item>
             </a-col>
             <a-col :sm="6" :xs="24" class="mb-25">
              <a-form-item label="Energieverbruik laag (kWh)" name="consumption_offpeak">
               <a-input v-model:value="productQuestionForm.consumption_offpeak"
                        name="consumption_offpeak"
                        onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
                        onpaste="let pasteData = event.clipboardData.getData('text'); if(pasteData){pasteData.replace(/[^0-9]*/g,'');}"
                        placeholder="Verbruik in piekuren"
                        type="number"/>
              </a-form-item>
             </a-col>
             <a-col :sm="6" :xs="24" class="mb-25">
              <a-form-item label="Energieteruglevering hoog (kWh)" name="feedin_peak">
               <a-input v-model:value="productQuestionForm.feedin_peak"
                        name="feedin_peak"
                        onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
                        onpaste="let pasteData = event.clipboardData.getData('text'); if(pasteData){pasteData.replace(/[^0-9]*/g,'');}"
                        placeholder="Teruglevering in daluren"
                        type="number"/>
              </a-form-item>
             </a-col>
             <a-col :sm="6" :xs="24" class="mb-25">
              <a-form-item label="Energieteruglevering laag (kWh)" name="feedin_offpeak">
               <a-input v-model:value="productQuestionForm.feedin_offpeak"
                        name="feedin_offpeak"
                        onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
                        onpaste="let pasteData = event.clipboardData.getData('text'); if(pasteData){pasteData.replace(/[^0-9]*/g,'');}"
                        placeholder="Teruglevering in piekuren"
                        type="number"/>
              </a-form-item>
             </a-col>
            </a-row>
           </sdCards>

           <!-- Contractgegevens Card -->
           <sdCards class="mb-25" title="Contractgegevens">
            <a-row :gutter="30">
             <a-col :sm="8" :xs="24" class="mb-25">
              <a-form-item label="Fysieke capaciteit" name="physical_capacity">
               <a-select v-model:value="productQuestionForm.physical_capacity" :allowClear="true"
                         class="sDash_fullwidth-select"
                         name="physical_capacity"
                         placeholder="Selecteer capaciteit"
                         size="large">
                <a-select-option v-for="option in physicalCapacityOptions" :key="option.value" :value="option.value">
                 {{ option.label }}
                </a-select-option>
               </a-select>
              </a-form-item>
             </a-col>
             <a-col :sm="8" :xs="24" class="mb-25">
              <a-form-item label="Contract einddatum" name="contract_end_date">
               <a-date-picker v-model:value="productQuestionForm.contract_end_date"
                              :format="dateFormat"
                              :placeholder="dateFormat"
                              :value-format="'YYYY-MM-DD'"
                              name="contract_end_date"
                              size="large"
                              style="width: 100%"/>
              </a-form-item>
             </a-col>
             <a-col :sm="8" :xs="24" class="mb-25">
              <a-form-item label="Contract type" name="contract_type">
               <a-select v-model:value="productQuestionForm.contract_type" :allowClear="true"
                         class="sDash_fullwidth-select"
                         name="contract_type"
                         placeholder="Selecteer type"
                         size="large">
                <a-select-option v-for="option in contractTypeOptions" :key="option.value" :value="option.value">
                 {{ option.label }}
                </a-select-option>
               </a-select>
              </a-form-item>
             </a-col>
            </a-row>
           </sdCards>

           <!-- Aanvullende gegevens Card -->
           <sdCards class="mb-25" title="Aanvullende gegevens">
            <a-row :gutter="30">
             <a-col :sm="8" :xs="24" class="mb-25">
              <a-form-item label="Klantbehoefte" name="customer_wishes">
               <a-select v-model:value="productQuestionForm.customer_wishes" :allowClear="true"
                         class="sDash_fullwidth-select"
                         name="customer_wishes"
                         placeholder="Selecteer klantbehoefte"
                         size="large">
                <a-select-option v-for="option in customerWishesOptions" :key="option.value" :value="option.value">
                 {{ option.label }}
                </a-select-option>
               </a-select>
              </a-form-item>
             </a-col>
             <a-col :sm="8" :xs="24" class="mb-25">
              <a-form-item label="Aantal zonnepanelen" name="number_of_solar_panels">
               <a-input v-model:value="productQuestionForm.number_of_solar_panels"
                        name="number_of_solar_panels"
                        onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
                        onpaste="let pasteData = event.clipboardData.getData('text'); if(pasteData){pasteData.replace(/[^0-9]*/g,'');}"
                        placeholder="Aantal geïnstalleerde panelen"
                        type="number"/>
              </a-form-item>
             </a-col>
             <a-col :sm="8" :xs="24" class="mb-25">
              <a-form-item label="Belastbaar inkomen (€)" name="taxable_income">
               <a-input v-model:value="productQuestionForm.taxable_income"
                        name="taxable_income"
                        placeholder="Jaarlijks belastbaar inkomen"
                        step="0.01"
                        type="number"/>
              </a-form-item>
             </a-col>
            </a-row>
           </sdCards>

           <!-- Klantwensen Card -->
           <sdCards class="mb-25" title="Huidige situatie">
            <a-row :gutter="30">
             <a-col :xs="24" class="mb-25">
              <a-form-item label="Omschrijving huidige situatie van de klant"
                           name="notes">
               <a-textarea v-model:value="productQuestionForm.notes"
                           name="notes"
                           placeholder="Beschrijf op deze plaats de actuele situatie van de klant op een duidelijke en overzichtelijke manier...."
                           rows="4"/>
              </a-form-item>
             </a-col>
            </a-row>
           </sdCards>
           <ActionWrapper>
            <div class="step-action-wrap">
             <div class="step-action-inner">
              <a-row>
               <a-col :xs="24">
                <div class="steps-action">
                 <sdButton class="btn-prev" type="primary" @click.prevent="() => prevEan()">
                  <sdFeatherIcons size="16" type="arrow-left"/>
                  <span>Vorige</span>
                 </sdButton>
                 <a-button :disabled="loadingCalculatePrice"
                           :loading="loadingCalculatePrice" class="btn-next"
                           html-type="submit"
                           type="primary">
                  <span>Volgende</span>
                  <sdFeatherIcons size="16" type="arrow-right"/>
                 </a-button>
                </div>
               </a-col>
              </a-row>
             </div>
            </div>
           </ActionWrapper>
          </a-form>

         </template>
         <template #relation>
          {{ order.relation }}
          <Relation
           :key="relKey"
           ref="relationComponentRef"
           :disable-is-business="true"
           :is-order-create="true"
           :maxAge="80"
           :minAge="18"
           :relation="order.relation"
           :show-card-save-button="false"
           :show-footer="false"
           :show-global-save-button="true"
           :showHeader="false"
           type="ADD"
           @submit-external="handleRelationOnOrder($event)"
          ></Relation>
          <ActionWrapper>
           <div class="step-action-wrap">
            <div class="step-action-inner">
             <a-row>
              <a-col :xs="24">
               <div class="steps-action">
                <sdButton class="btn-prev" type="primary" @click="() => prev()">
                 <sdFeatherIcons size="16" type="arrow-left"/>
                 <span>Vorige</span>
                </sdButton>
                <sdButton class="btn-next" type="primary"
                          @click.prevent="$refs.relationComponentRef.submitExternal()">
                 <span>Volgende</span>
                 <sdFeatherIcons size="16" type="arrow-right"/>
                </sdButton>
               </div>
              </a-col>
             </a-row>
            </div>
           </div>
          </ActionWrapper>
         </template>
         <template #summary>
          <Main>
           <a-row :gutter="25">
            <a-col :md="12" :xs="24">
             <sdCards class="mb-25" title="ROI Rapport Service">
              <div class="card productRevision-card">
               <figure>
                <sdFeatherIcons size="64" style="color: #52c41a" type="trending-up"/>
               </figure>
               <figcaption>
                <div class="card__content" style="margin-top:20px">
                 <h4>Rendementsanalyse</h4>
                 <p>Een professioneel ROI-rapport voor uw energieproject. Onze experts analyseren uw energieverbruik en
                  stellen een gedetailleerd rapport op met inzicht in besparingsmogelijkheden en de verwachte
                  terugverdientijd."</p>
                </div>
               </figcaption>
              </div>
             </sdCards>
            </a-col>
            <a-col :md="12" :xs="24">
             <RelationSummaryCard :order="order" class="mb-25"/>
            </a-col>
           </a-row>

           <!-- Energy Data Summary -->
           <a-row :gutter="25">
            <a-col :md="12" :xs="24">
             <sdCards class="mb-25" title="Energiegegevens Overzicht">
              <div class="summary-section">
               <div class="summary-item">
                <span class="summary-label">Energieverbruik hoog:</span>
                <span class="summary-value">{{ order.extraData.consumption_peak || 0 }} kWh</span>
               </div>
               <div class="summary-item">
                <span class="summary-label">Energieverbruik laag:</span>
                <span class="summary-value">{{ order.extraData.consumption_offpeak || 0 }} kWh</span>
               </div>
               <div class="summary-item">
                <span class="summary-label">Energieteruglevering hoog:</span>
                <span class="summary-value">{{ order.extraData.feedin_peak || 0 }} kWh</span>
               </div>
               <div class="summary-item">
                <span class="summary-label">Energieteruglevering laag:</span>
                <span class="summary-value">{{ order.extraData.feedin_offpeak || 0 }} kWh</span>
               </div>
               <div class="summary-item">
                <span class="summary-label">Aantal zonnepanelen:</span>
                <span class="summary-value">{{ order.extraData.number_of_solar_panels || 0 }} panelen</span>
               </div>
              </div>
             </sdCards>
            </a-col>
            <a-col :md="12" :xs="24">
             <sdCards class="mb-25" title="Contractgegevens Overzicht">
              <div class="summary-section">
               <div class="summary-item">
                <span class="summary-label">Fysieke capaciteit:</span>
                <span class="summary-value">{{ order.extraData.physical_capacity || 'Niet opgegeven' }}</span>
               </div>
               <div class="summary-item">
                <span class="summary-label">Contract einddatum:</span>
                <span class="summary-value">{{ formatContractDate(order.extraData.contract_end_date) }}</span>
               </div>
               <div class="summary-item">
                <span class="summary-label">Contract type:</span>
                <span class="summary-value">{{ formatContractType(order.extraData.contract_type) }}</span>
               </div>
               <div class="summary-item">
                <span class="summary-label">Belastbaar inkomen:</span>
                <span class="summary-value">{{ formatIncome(order.extraData.taxable_income) }}</span>
               </div>
               <div class="summary-item">
                <span class="summary-label">Klantbehoefte:</span>
                <span class="summary-value">{{ order.extraData.customer_wishes || 'Niet opgegeven' }}</span>
               </div>
              </div>
             </sdCards>
            </a-col>
           </a-row>

           <!-- Customer Situation -->
           <a-row v-if="order.extraData.notes" :gutter="25">
            <a-col :xs="24">
             <sdCards class="mb-25" title="Huidige Situatie">
              <p style="margin: 0; line-height: 1.6;">{{ order.extraData.notes }}</p>
             </sdCards>
            </a-col>
           </a-row>

           <!-- Next Steps Info -->
           <a-row :gutter="25">
            <a-col :xs="24">
             <sdCards class="mb-25" title="Vervolgstappen">
              <a-timeline>
               <a-timeline-item color="blue">
                <strong>Aanvraag ontvangen</strong><br/>
                Uw ROI rapport aanvraag wordt verwerkt
               </a-timeline-item>
               <a-timeline-item color="orange">
                <strong>Analyse uitvoeren</strong><br/>
                Onze experts analyseren uw energiegegevens
               </a-timeline-item>
               <a-timeline-item color="green">
                <strong>Rapport opleveren</strong><br/>
                U ontvangt het complete ROI rapport binnen 1-2 dagen
               </a-timeline-item>
              </a-timeline>
             </sdCards>
            </a-col>
           </a-row>
          </Main>

          <ActionWrapper v-if="!isFinished">
           <div class="step-action-wrap">
            <div class="step-action-inner">
             <a-row>
              <a-col :xs="24">
               <div class="steps-action">
                <sdButton class="btn-prev" type="light" @click="() => prev()">
                 <sdFeatherIcons size="16" type="arrow-left"/>
                 <span>Terug</span>
                </sdButton>
                <a-button :disabled="loadingCreateOrder" :loading="loadingCreateOrder" class="btn-signin" size="large"
                          style="min-width: 120px;"
                          type="primary"
                          @click="handleCreateOrder">
                 Aanvragen
                </a-button>
               </div>
              </a-col>
             </a-row>
            </div>
           </div>
          </ActionWrapper>
         </template>
        </Steps>
       </WizardWrapper>
      </a-col>
     </a-row>
    </WizardBlock>
   </a-col>
  </a-row>
 </Main>
</template>
<script>
import {
 CardWrapper,
 ConnectionCardWrapper,
 ConnectionDetailsWrapper,
 EstimateButtonWrapper,
 FigureWizards,
 OrderSummary,
 ProductTable,
 WizardBlock,
 WizardWrapper,
} from './Style';
import {BasicFormWrapper, DatePickerWrapper, Main, ModalMain} from '../styled';
import Steps from "./component/steps";
import {useStore} from "vuex";
import {computed, onMounted, reactive, ref, watchEffect} from "vue";
import Relation from "../../components/relation/Relation";
import ProductCards from "./component/ProductCards";
import FlowCards from "./component/FlowCards";
import {
 capacityCodeElectricityOptions,
 capacityCodeGasOptions,
 defaultOptions,
 meterTypeOptions,
 switchTypeOptions,
 usageEstimationOptions
} from "@/utility/enums";
import {ProductOverviewTable} from "./component/style";
import {ActionWrapper} from "@/components/steps/style";
import {checkCheckBox, integerValidator, postalCodeValidator} from "@/utility/validators";
import Aom from "../../components/aom/Aom";
import ProductInfoCard from "./component/ProductInfoCard";
import ProductSummaryInfoCard from "./component/ProductSummaryInfoCard";
import ConnectionTable from "./component/ConnectionTable";
import RelationSummaryCard from "./component/RelationSummaryCard";
import RelationCard from "./component/RelationCard";
import moment from "moment";
import {Empty, notification} from "ant-design-vue";
import {useRoute, useRouter} from "vue-router";
import Vue3Signature from "vue3-signature";

const OrderCreateEnergy = {
 name: 'OrderCreateEnergy',
 components: {
  ConnectionTable,
  RelationSummaryCard,
  CardWrapper,
  WizardBlock,
  Main,
  ModalMain,
  Steps,
  FigureWizards,
  WizardWrapper,
  BasicFormWrapper,
  ProductTable,
  OrderSummary,
  ConnectionDetailsWrapper,
  Relation,
  ProductCards,
  ConnectionCardWrapper,
  ProductInfoCard,
  RelationCard,
  ProductOverviewTable,
  ActionWrapper,
  EstimateButtonWrapper,
  Aom,
  FlowCards,
  ProductSummaryInfoCard,
  DatePickerWrapper,
  Vue3Signature,
 },
 data() {
  return {
   customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
   debounce: null,
   selectedAddress: {
    postalCode: '',
    houseNumber: '',
   },
   dateFormat: 'DD-MM-YYYY',
   simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
  };
 },
 watch: {
  addressForm: {
   handler(value) {
    if ((value.postalCode && value.houseNumber) && (this.selectedAddress.postalCode !== value.postalCode || this.selectedAddress.houseNumber !== value.houseNumber)) {
     this.selectedAddress.postalCode = value.postalCode;
     this.selectedAddress.houseNumber = value.houseNumber;
     clearTimeout(this.debounce)
     this.debounce = setTimeout(() => {
      this.$store.dispatch("houseNumberAdditions", {
       postalCode: this.addressForm.postalCode,
       houseNumber: this.addressForm.houseNumber,
       country: this.addressForm.country,
       type: 'ENERGY',
      });
     }, 600)
    }
   },
   deep: true,
  }
 },
 setup() {
  const {state, dispatch} = useStore();
  const router = useRouter()
  const status = ref("process");
  const isFinished = ref(false);
  const current = ref(0);
  const {params} = useRoute();

  const addNotificationError = (err) => {
   notification.error({
    message: err,
   });
  };
  const relationComponentRef = ref();
  const houseNumberAdditionsOptions = computed(() => state.globalSearch.houseNumberAdditions);
  const globalSearchData = computed(() => state.globalSearch.data);
  const globalSearchLoading = computed(() => state.globalSearch.loadingSearch);
  const disabledGlobalSearchButton = computed(() => state.globalSearch.disabledGlobalSearchButton);
  const order = reactive(computed(() => state.roi.order));
  const loadingCreateOrder = computed(() => state.roi.loadingCreateOrder);
  const loadingPreFillRelationOnOrder = computed(() => state.roi.loadingPreFillRelationOnOrder);
  const loadingCalculatePrice = computed(() => state.roi.loadingCalculatePrice);
  const loadingHouseNumberAdditions = computed(() => state.globalSearch.loadingHouseNumberAdditions);
  const flowQuestionsForm = ref();
  const customerApprovalsForm = ref();
  const signatureError = ref(false);
  const signature1 = ref();
  const showMultiSiteDisabledError = ref(false);
  let relKey = ref(0);

  const next = () => {
   status.value = "process";
   current.value = current.value + 1;
  };

  const prev = () => {
   status.value = "process";
   current.value = current.value - 1;
  };

  const prevEan = () => {
   dispatch('resetCreateOrderConnections');
   status.value = "process";
   current.value = current.value - 1;
  };

  const done = () => {
   const confirm = window.confirm("Are sure to submit order?");
   if (confirm) {
    status.value = "finish";
    isFinished.value = true;
    current.value = 0;
   }
  };

  const form = reactive({
   lastName: '',
   firstName: '',
   middleName: '',
  });

  const addressForm = reactive({
   postalCode: '',
   houseNumber: '',
   houseNumberAddition: '',
   country: 'NL'
  });
  const addressConnectionForm = reactive({
   postalCode: '',
   houseNumber: '',
   houseNumberAddition: '',
   country: 'NL',
   type: '',
  });
  const productQuestionForm = reactive({
   model: '',
   consumption_peak: 0,
   consumption_offpeak: 0,
   feedin_peak: 0,
   feedin_offpeak: 0,
   physical_capacity: '',
   contract_end_date: '',
   contract_type: '',
   customer_wishes: '',
   notes: '',
   number_of_solar_panels: 0,
   taxable_income: 0,
  });

  const questionRules = {
   model: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   consumption_peak: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   consumption_offpeak: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   feedin_peak: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   feedin_offpeak: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   physical_capacity: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   contract_end_date: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   contract_type: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   customer_wishes: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   notes: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   number_of_solar_panels: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
   taxable_income: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ]
  }
  const addressFormRules = {
   postalCode: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
    {
     validator: postalCodeValidator,
    },
   ],
   houseNumber: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
    {
     validator: integerValidator,
    },
   ],
   houseNumberAddition: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
  };

  const globalSearch = () => {
   dispatch('globalSearch', {
    postalCode: addressForm.postalCode,
    houseNumber: addressForm.houseNumber,
    houseNumberAddition: addressForm.houseNumberAddition !== null && addressForm.houseNumberAddition !== 'geen' ? addressForm.houseNumberAddition : null,
    country: 'NL',
    type: 'ENERGY',
   });

   dispatch('setProductId', params.productID);
  };

  const handleSelectRelation = async (data, type) => {
   const relation = data;
   if (type) {
    relation.type = type;
   }
   if (type === 'CONSUMER') {
    relation.companyName = null;
    relation.companyCocNumber = null;
   }
   await dispatch('resetROIOrder');
   await dispatch('preFillRelationOnROIOrder', {value: relation, stepRoute: next});
  };

  const handleRelationOnOrder = (data) => {
   dispatch('addRelationToROIOrder', {value: data, stepRoute: next})
  };

  const handleProductQuestions = () => {
   // Format the date to YYYY-MM-DD format for backend
   const formattedData = {...productQuestionForm};
   if (formattedData.contract_end_date) {
    try {
     const dateObj = moment(formattedData.contract_end_date);
     if (dateObj.isValid()) {
      formattedData.contract_end_date = dateObj.format('YYYY-MM-DD');
     } else {
      console.warn('Invalid date format:', formattedData.contract_end_date);
      formattedData.contract_end_date = null;
     }
    } catch (error) {
     console.error('Date formatting error:', error);
     formattedData.contract_end_date = null;
    }
   }
   dispatch('calculateROIPrice', {value: formattedData, stepRoute: next})
  };

  const orderCreateSuccessRoute = () => {
   router.push('/order');
  };

  const handleCreateOrder = () => {
   const orderValidators = [];
   signatureError.value = false;
   Promise.all(orderValidators).then(() => {
    // Ensure date is properly formatted before submission
    const orderData = JSON.parse(JSON.stringify(order.value));
    // Ensure productID is set from URL parameters
    orderData.productID = params.productID;
    if (orderData.extraData.contract_end_date) {
     try {
      const dateObj = moment(orderData.extraData.contract_end_date);
      if (dateObj.isValid()) {
       orderData.extraData.contract_end_date = dateObj.format('YYYY-MM-DD');
      } else {
       console.warn('Invalid date format:', orderData.extraData.contract_end_date);
       orderData.extraData.contract_end_date = null;
      }
     } catch (error) {
      console.error('Date formatting error:', error);
      orderData.extraData.contract_end_date = null;
     }
    }
    dispatch('createROIOrder', {successRoute: orderCreateSuccessRoute, orderData})
   })
    .catch(() => {
     addNotificationError('Vul alle benodigde informatie in.');
    });
  };

  const showUsageEstimator = ref(false);
  const selectedEanToEstimateUsage = ref(null)
  const estimateUsage = (ean) => {
   selectedEanToEstimateUsage.value = ean;
   showUsageEstimator.value = true;
  };

  watchEffect(() => {
   const activeElement = document.querySelectorAll(".ant-steps-item-active");
   const successElement = document.querySelectorAll(
    ".ant-steps-item-finish"
   );

   activeElement.forEach((element) => {
    if (element.previousSibling) {
     const bgImage = element.previousSibling;
     if (bgImage.classList.contains("success-step-item")) {
      bgImage.classList.remove("success-step-item");
     } else {
      bgImage.classList.remove("wizard-step-item");
     }
     bgImage.classList.add("wizard-steps-item-active");
    }
   });

   successElement.forEach((element) => {
    if (element.previousSibling) {
     const bgImage = element.previousSibling;
     bgImage.classList.remove("wizard-steps-item-active");
     bgImage.classList.add("success-step-item");
    }
   });
  });

  const pageSize = ref(10);

  const onShowSizeChange = (current, pageSize) => {
   current.value = current;
   pageSize.value = pageSize;
  };

  const onHandleChange = (current, pageSize) => {
   current.value = current;
   pageSize.value = pageSize;
  };

  const sigState = reactive({
   count: 0,
   option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(220,220,220)",
   },
   disabled: false
  })

  const clearSignature = () => {
   signature1.value.clear()
  }

  const physicalCapacityOptions = [
   {value: "1 x 10A", label: "1x10A"},
   {value: "1 x 25A", label: "1x25A (niet meer aan te vragen)"},
   {value: "1 x 35A", label: "1x35A (niet nieuw aan te vragen)"},
   {value: "1 x 40A", label: "1x40A"},
   {value: "3 x 25A", label: "3x25A"},
   {value: "3 x 35A", label: "3x35A"},
   {value: "3 x 40A", label: "3x40A"},
   {value: "3 x 50A", label: "3x50A"},
   {value: "3 x 63A", label: "3x63A"},
   {value: "3 x 80A", label: "3x80A"},
   {value: ">3x80A t/m 100kVA", label: ">3x80A t/m 100kVA"},
   {value: ">100kVa t/m 160kVA", label: ">100kVA t/m 160kVA"},
   {value: ">160kVa t/m 630kVA", label: ">160kVA t/m 630kVA"},
   {value: ">630kVa t/m 1MVA", label: ">630kVA t/m 1MVA"},
   {value: ">1MVA t/m 2MVA", label: ">1MVA t/m 2MVA"},
   {value: ">2MVA t/m 5MVA", label: ">2MVA t/m 5MVA"},
   {value: ">5MVA t/m 10MVA", label: ">5MVA t/m 10MVA"},
   {value: ">10MVA", label: ">10MVA"}
  ];

  const contractTypeOptions = [
   {value: "Dynamisch", label: "Dynamisch"},
   {value: "Vast", label: "Vast"},
   {value: "Variabel", label: "Variabel"}
  ];

  const customerWishesOptions = [
   {value: "Peakshaving", label: "Peakshaving"},
   {value: "Onbalans traden", label: "Onbalans traden"},
   {value: "Net-zero", label: "Net-zero"},
   {value: "Overig", label: "Overig"}
  ];

  const formatContractDate = (dateValue) => {
   if (!dateValue) return 'Niet opgegeven';
   try {
    const formatted = moment(dateValue);
    if (!formatted.isValid()) return 'Ongeldige datum';
    return formatted.format('DD-MM-YYYY');
   } catch (error) {
    return 'Ongeldige datum';
   }
  };

  const formatContractType = (type) => {
   if (!type) return 'Niet opgegeven';
   const typeMap = {
    'DYNAMIC': 'Dynamisch',
    'VARIABLE': 'Variabel',
    'FIXED': 'Vast'
   };
   return typeMap[type] || type;
  };

  const formatIncome = (income) => {
   if (!income || income === 0) return 'Niet opgegeven';
   return `€ ${parseFloat(income).toLocaleString('nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
  };

  onMounted(async () => {
   await dispatch('resetROIOrder');
  });

  return {
   sigState,
   steps: [
    {
     title: "Adres",
     content: "address",
    },
    {
     title: "Huidige situatie",
     content: "questions",
    },
    {
     title: "Klantgegevens",
     content: "relation",
    },
    {
     title: "Overzicht",
     content: "summary",
    },
   ],
   clearSignature,
   signature1,
   addressForm,
   addressConnectionForm,
   houseNumberAdditionsOptions,
   addressFormRules,
   globalSearchData,
   order,
   globalSearchLoading,
   disabledGlobalSearchButton,
   relationComponentRef,
   showUsageEstimator,
   switchTypeOptions,
   meterTypeOptions,
   defaultOptions,
   capacityCodeElectricityOptions,
   capacityCodeGasOptions,
   usageEstimationOptions,
   handleSelectRelation,
   globalSearch,
   done,
   prev,
   next,
   handleRelationOnOrder,
   handleCreateOrder,
   estimateUsage,
   isFinished,
   current,
   onHandleChange,
   onShowSizeChange,
   pageSize,
   form,
   moment,
   loadingPreFillRelationOnOrder,
   prevEan,
   flowQuestionsForm,
   customerApprovalsForm,
   checkCheckBox,
   signatureError,
   loadingCreateOrder,
   showMultiSiteDisabledError,
   loadingHouseNumberAdditions,
   relKey,
   integerValidator,
   questionRules,
   productQuestionForm,
   physicalCapacityOptions,
   contractTypeOptions,
   customerWishesOptions,
   handleProductQuestions,
   loadingCalculatePrice,
   formatContractDate,
   formatContractType,
   formatIncome,
  };
 },
};

export default OrderCreateEnergy;
</script>
<style>
.steps-content {
 display: block !important;
}

.status-badge {
 font-size: 12px;
 padding: 0 12.41px;
 line-height: 1.9;
 font-weight: 500;
 border-radius: 12px;
 text-transform: capitalize;
 display: inline-block !important;
 background-color: #519c79;
 color: #ffffff;
}

.ant-collapse-item {
 margin-bottom: 15px !important;;
}

.ant-collapse .collapse-title {
 width: 100% !important;
 display: flex !important;
 align-items: baseline !important;
}

.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector, .ant-input[disabled] {
 color: #000000 !important;;
}

.signature canvas {
 width: 400px;
 height: 200px;
}

.checkbox-group .ant-form-item-control-input {
 min-height: 0px !important;
}

.ant-calendar-picker-container {
 z-index: 999999 !important;
}

.summary-section {
 display: flex;
 flex-direction: column;
 gap: 16px;
}

.summary-item {
 display: flex;
 justify-content: space-between;
 align-items: flex-start;
 padding: 0px 5px;
}

.summary-label {
 font-weight: 500;
 color: #595959;
 flex: 1;
 margin-right: 16px;
}

.summary-value {
 font-weight: 600;
 color: #262626;
 text-align: right;
 flex: 0 0 auto;
}

@media (max-width: 768px) {
 .summary-item {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
 }

 .summary-label {
  margin-right: 0;
 }

 .summary-value {
  text-align: left;
 }
}
</style>
